var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchitecturalEng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke-width:5.53px;}.cls-2{stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.23,
    y1: 189.76,
    x2: 172.06,
    y2: 189.76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "26.2 189.76 26.2 116.21 69.71 116.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "69.71 189.76 69.71 62.28 116.91 87.41 116.91 187.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "118.13 133.99 162.26 133.99 162.26 189.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.2,
    y1: 132.15,
    x2: 68.49,
    y2: 132.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.2,
    y1: 149.31,
    x2: 68.49,
    y2: 149.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.32,189.14V169.53s0-14.09,12.87-14.09c0,0,11.65,1.22,11.65,14.71v19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.97,
    y1: 97.21,
    x2: 81.97,
    y2: 103.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93,
    y1: 97.21,
    x2: 93,
    y2: 103.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.81,
    y1: 97.21,
    x2: 102.81,
    y2: 103.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.97,
    y1: 114.37,
    x2: 81.97,
    y2: 120.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93,
    y1: 114.37,
    x2: 93,
    y2: 120.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.81,
    y1: 114.37,
    x2: 102.81,
    y2: 120.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.97,
    y1: 132.15,
    x2: 81.97,
    y2: 138.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93,
    y1: 132.15,
    x2: 93,
    y2: 138.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.81,
    y1: 132.15,
    x2: 102.81,
    y2: 138.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.97,
    y1: 149.92,
    x2: 81.97,
    y2: 156.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93,
    y1: 149.92,
    x2: 93,
    y2: 156.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.81,
    y1: 149.92,
    x2: 102.81,
    y2: 156.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 81.97,
    y1: 167.69,
    x2: 81.97,
    y2: 173.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93,
    y1: 167.69,
    x2: 93,
    y2: 173.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 102.81,
    y1: 167.69,
    x2: 102.81,
    y2: 173.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.48,56.51a13.11,13.11,0,1,0,13.11,13.11A13.12,13.12,0,0,0,161.48,56.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167,29.13V42.35l2,.55a28.74,28.74,0,0,1,6.74,2.73l1.83,1,9.08-9.09,7.33,7.32-9,9,1.09,1.84a28.8,28.8,0,0,1,3,7.06l.55,2H202V75.18H189.86l-.52,2.08a28.46,28.46,0,0,1-3.07,7.44l-1.07,1.83,8.32,8.33-7.33,7.33-8.36-8.36-1.83,1a27.92,27.92,0,0,1-7.6,3l-2.11.51v11.72H155.92v-12l-2-.58a28,28,0,0,1-7.25-3.28l-1.86-1.18-8.58,8.58-7.34-7.33,8.89-8.87-1-1.81a28.35,28.35,0,0,1-2.63-7.08l-.48-2.14H121V64.07H134.1l.59-1.95a27.89,27.89,0,0,1,3-6.56l1.11-1.84-9.32-9.34,7.33-7.33,9.48,9.48,1.82-1a28.2,28.2,0,0,1,6.55-2.62l2.06-.54V29.13H167"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitecturalEng);
export default __webpack_public_path__ + "static/media/ARCHITECTURAL_ENG.bff1c20ab2ff086fd6df9ce375b404f1.svg";
export { ForwardRef as ReactComponent };